import { useSmartMutation, useSmartQuery } from "@shared/api/queries/hooks";
import { QueryKeyFactory } from "@shared/api/queries/queryKeyFactory";
import { subscriptionApi } from "./api";

import {
  useTenantId,
} from "@shared/selectors/globalSelectors";
import { toast } from "@shared/hooks/use-toast";
import { queryClient } from "@shared/api/queries/queryClient";


// Hook to get all utilities
export const usePlanSubscription= () => {
  const key = QueryKeyFactory.module.onboarding.subscriptions.subscriptionList();
  return useSmartQuery(
    key as unknown[],
    () => subscriptionApi.getSubscriptionPlan(),
  );
};

export const useAddOnsList= () => {
    const tenantId = useTenantId();
  const key = QueryKeyFactory.module.onboarding.subscriptions.addOnsList();
  return useSmartQuery(
    key as unknown[],
    () => subscriptionApi.getAddOnsList(tenantId),
  );
};

export const useCurrentSubscription= () => {
  const tenantId = useTenantId();
  const key = QueryKeyFactory.module.onboarding.subscriptions.currentSubscription();
  return useSmartQuery(
    key as unknown[],
    () => subscriptionApi.getCurrentSubscription(tenantId),
  );
}
export const useTrackRequests= () => {
  const tenantId = useTenantId();
  const key = QueryKeyFactory.module.onboarding.subscriptions.supportRequests();
  return useSmartQuery(
    key as unknown[],
    () => subscriptionApi.getSupportRequests(tenantId),
  );
}

export const usePostAddSubscription = () =>
  useSmartMutation(subscriptionApi.postAddSubscription, {
    onSuccess: () => {
      toast({
        title: "Success",
        description: `Successfully raised ticket to add this package.`,
        variant: "default",
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
    },
  });

export const usePostAddons = () =>
  useSmartMutation(subscriptionApi.postAddons, {
    onSuccess: () => {
      toast({
        title: "Success",
        description: `Successfully raised ticket to add this package.`,
        variant: "default",
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Error",
        description: error.message,
        variant: "destructive",
      });
    },
  });